import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

interface ILayoutConf {
  navigationPos?: string; // side, top
  sidebarStyle?: string; // full, compact, closed
  dir?: string; // ltr, rtl
  layoutInTransition?: boolean;
  isMobile?: boolean;
  useBreadcrumb?: boolean;
  breadcrumb?: string; // simple, title
  topbarFixed?: boolean;
}
interface ILayoutChangeOptions {
  duration?: number;
  transitionClass?: boolean;
}
interface IAdjustScreenOptions {
  browserEvent?: any;
  route?: string;
}

@Injectable()
export class LayoutService {
  public layoutConf: any;
  public layoutConfSubject;
  public layoutConf$: Observable<any>;
  public isMobile: boolean;
  public currentRoute: string;
  public fullWidthRoutes = ['shop'];

  private videoCallDrawerOpened = new BehaviorSubject<boolean>(true);
  videoCallDrawerOpened$ = this.videoCallDrawerOpened.asObservable();

  constructor() {
    this.layoutConfSubject = new BehaviorSubject<ILayoutConf>(this.layoutConf);
    this.layoutConf$ = this.layoutConfSubject.asObservable();
    this.setAppLayout();
  }

  openVideoCallDrawer() {
    this.videoCallDrawerOpened.next(true);
  }
  closeVideoCallDrawer() {
    this.videoCallDrawerOpened.next(false);
  }

  setAppLayout() {
    //* ******* SET YOUR LAYOUT OPTIONS HERE *********
    this.layoutConf = {
      navigationPos: 'side', // side, top
      sidebarStyle: 'full', // full, compact, closed
      dir: 'ltr', // ltr, rtl
      useBreadcrumb: true,
      topbarFixed: false,
      breadcrumb: 'title', // simple, title
    };
  }

  publishLayoutChange(lc: ILayoutConf, opt: ILayoutChangeOptions = {}) {
    const duration = opt.duration || 250;
    if (!opt.transitionClass) {
      this.layoutConf = Object.assign(this.layoutConf, lc);
      return this.layoutConfSubject.next(this.layoutConf);
    }

    this.layoutConf = Object.assign(this.layoutConf, lc, {
      layoutInTransition: true,
    });
    this.layoutConfSubject.next(this.layoutConf);

    setTimeout(() => {
      this.layoutConf = Object.assign(this.layoutConf, {
        layoutInTransition: false,
      });
      this.layoutConfSubject.next(this.layoutConf);
    }, duration);
  }

  adjustLayout(options: IAdjustScreenOptions = {}) {
    let sidebarStyle: string;
    this.isMobile = this.isSm();
    this.currentRoute = options.route || this.currentRoute;
    sidebarStyle = this.isMobile ? 'closed' : this.layoutConf.sidebarStyle;

    if (this.currentRoute) {
      this.fullWidthRoutes.forEach((route) => {
        if (this.currentRoute.indexOf(route) !== -1) {
          sidebarStyle = 'closed';
        }
      });
    }

    this.publishLayoutChange({
      isMobile: this.isMobile,
      sidebarStyle: sidebarStyle,
    });
  }
  isSm() {
    return window.matchMedia('(max-width: 959px)').matches;
  }
}
